import React, { useState } from 'react';
import LabelText from '../../ui/LabelText';
import LabelNumber from '../../styled-components/LabelNumber';
import { getBackgroundColor, getBorderColor } from '../../types/IPerformanceVersion2';
import PositiveArrow from '../../assets/icons/PositiveArrow.png';
import NegativeArrow from '../../assets/icons/NegativeArrow.png';
import UpArrow from '../../assets/icons/ArrowUp.png';
import DownArrow from '../../assets/icons/ArrowDown.png';
import AttributesBar from '../../components/ClubDetail/PerformanceVersion2/AttributesBar';
import SimulationAttributes from '../../components/ClubDetail/PerformanceVersion2/SimulationAttributes';
import { SpiderSwapGraph } from '../../components/ClubDetail/PerformanceVersion2/SpiderSwapGraph';
import SquareBarChart from '../../components/ClubDetail/ClubFinancial/SquareBarchart';
import { formatNumberToKAndM } from '../../utils/formatNumberToKandM';
import SimulationPlayersTable from '../../components/ClubDetail/PerformanceVersion2/SimulationPlayersTable';
import Switch from '../../ui/CustomSwitch';
import InfoIcon from '../../assets/icons/infoicon.svg';
import { SortableKeys } from '../../types/IPlayerComparison';
import { processTeamSwapArchetypeData, processTeamArchetypeData } from '../../types/IRolesPlayedUtils';
import SecondaryButton from '../../ui/SecondaryButton';
import LoadingSpinner from '../../ui/LoadingSpinner';

import { ChemistryPlayerPositions } from '../../types/IOption';
import { hasPlayersFromDifferentClubs } from '../../utils/drawChemistrys';

interface SystemFitValuesAndContentProps {
  teamId: number;
  seasonId: number;
  teamAttributesData?: any;
  simulationAttributesData?: any;
  teamFinancialSimulationData?: any;
  overallSystemFitScore?: number;
  overAllswappSystemFitScore?: number;
  inPlayerIds?: number[];
  outPlayerIds?: number[];
  squadPlayerComparisonData?: any;
  sortKey?: SortableKeys;
  setSortKey?: React.Dispatch<React.SetStateAction<SortableKeys>>;
  simulationData?: any;
  comparisonTeamData?: any[];
  clubCompareId?: number;
  activeArcheTypeName?: string;
  archetypes?: any[];
  isCompareBalckLine?: boolean;
  swapDataLoading?: boolean;
  compareClubLogoUrl?: string;
  compareClubName?: string;
  compareClubseasonLabel?: string;
  // Computed values instead of functions
  stylisticFitValue?: number | "";
  stylisticFitForCoachValue?: number | "";
  compareStylisticFitValue?: number | "";
  afterScoreValue?: number;
  improvementValue?: number;
  clubNameValue?: string;
  seasonNameValue?: string;
  clubNameForCoachValue?: string;
  seasonNameForCoachValue?: string;
  playingStyleForCoachValue?: string;
  targetedFormationValue?: string;
  targetedSeasonNameValue?: string;
  targetTeamIdValue?: number;
  targetedArcheTypeFormation?: string;
  targetedFormation?: string;
  activeTeamGraph?: string;
  archeTypeBy?: string;
  positionResults?: ChemistryPlayerPositions[];
}

const SystemFitValuesAndContent: React.FC<SystemFitValuesAndContentProps> = ({
  teamId,
  seasonId,
  teamAttributesData,
  simulationAttributesData,
  teamFinancialSimulationData,
  overallSystemFitScore = 0,
  overAllswappSystemFitScore = 0,
  inPlayerIds = [],
  outPlayerIds = [],
  squadPlayerComparisonData,
  sortKey = "attackContribution" as SortableKeys,
  setSortKey = () => {},
  simulationData,
  comparisonTeamData,
  clubCompareId = 0,
  activeArcheTypeName = "",
  archetypes = [],
  isCompareBalckLine = false,
  swapDataLoading = false,
  compareClubLogoUrl,
  compareClubName,
  compareClubseasonLabel = "",
  // Computed values with defaults
  stylisticFitValue = 68,
  stylisticFitForCoachValue = 65,
  compareStylisticFitValue = 70,
  afterScoreValue = 68,
  improvementValue = 0,
  clubNameValue = "",
  seasonNameValue = "",
  clubNameForCoachValue = "",
  seasonNameForCoachValue = "",
  playingStyleForCoachValue = "",
  targetedFormationValue = "",
  targetedSeasonNameValue = "",
  targetTeamIdValue = 0,
  targetedArcheTypeFormation = "",
  targetedFormation = "",
  activeTeamGraph = "",
  archeTypeBy = "archetype",
  positionResults = []
}) => {

  // Create functions that return the computed values for compatibility
  const getStylisticFit = () => stylisticFitValue;
  const getStylisticFitForCoach = () => stylisticFitForCoachValue;
  const getCompareStylisticFit = () => compareStylisticFitValue;
  const getAfterScore = () => afterScoreValue;
  const getImprovement = () => improvementValue;
  const getClubName = () => clubNameValue;
  const getSeasonName = () => seasonNameValue;
  const getClubNameForCoach = () => clubNameForCoachValue;
  const getSeasonNameForCoach = () => seasonNameForCoachValue;
  const getPlayingStyleForCoach = () => playingStyleForCoachValue;
  const getTargetedFormation = () => targetedFormationValue;
  const getTargetedSeasonName = () => targetedSeasonNameValue;
  const getTargetTeamId = () => targetTeamIdValue;

  const getDifferenceValue = (beforeValue: number, afterValue: number, isAge: boolean = false) => {
    const diff = afterValue - beforeValue;
    return isAge ? diff.toFixed(1) : diff.toFixed(2);
  };

  return (
    <div className='bottom-container' style={{display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '30px', paddingBottom: "30px"}}>
      {/* Value Box 1 + Content 1 */}

      <div style={{marginTop: '10px'}}>
        <p style={{width: '1065px', fontFamily: 'Aeonik, sans-serif', fontSize: '20px', fontStyle: 'normal', fontWeight: 300, color:'#7C7D79'}} className="valuegraph-toggle-text">
          Team Attributes: A percentile ranking that measures how each team performs across different facets of the game. Scores are calculated relative to all teams within our model. When simulating a player's potential effect on these attributes, we account for the relative differences in difficulty and style between the leagues in question
        </p>
        {/* Value Box 2 + Content 2 */}
        <div id='pitch-attributes-for-pitch' style={{width: '1065px', marginTop: "8px", display: 'flex', flexDirection: "column", gap: "10px", backgroundColor: "#F2F5EE", padding: "8px", borderRadius: "8px", border: "1px solid #DADADA"}}>
          <div className='values-container'>
            <div className='values-box' style={{ backgroundColor: "white", width: '100%', height: "auto"  }}>
              <div className='values-box-content'>
                <div className='content-value'>
                  <LabelText className="secondary-cta-text">Final third</LabelText>
                  <AttributesBar
                    height={28}
                    width={200}
                    beforeValue={teamAttributesData?.finalThird?.avgScore || 0}
                    afterValue={simulationAttributesData?.teamAttributesNew?.finalThird?.avgScore || 0}
                    inPlayerIds={inPlayerIds}
                    outPlayerIds={outPlayerIds}
                    color={getBackgroundColor(teamAttributesData?.finalThird?.avgScore || 0)}
                    positionResults={positionResults}
                    teamId={teamId}
                  />
                </div>
                <div className='content-value'>
                  <LabelText className="secondary-cta-text">Build up play</LabelText>
                  <AttributesBar
                    height={28}
                    width={200}
                    beforeValue={teamAttributesData?.buildUpPlay?.avgScore || 0}
                    afterValue={simulationAttributesData?.teamAttributesNew?.buildUpPlay?.avgScore || 0}
                    inPlayerIds={inPlayerIds}
                    outPlayerIds={outPlayerIds}
                    color={getBackgroundColor(teamAttributesData?.buildUpPlay?.avgScore || 0)}
                    positionResults={positionResults}
                    teamId={teamId}
                  />
                </div>
                <div className='content-value'>
                  <LabelText className="secondary-cta-text">Defensive</LabelText>
                  <AttributesBar
                    height={28}
                    width={200}
                    beforeValue={teamAttributesData?.defence?.avgScore || 0}
                    afterValue={simulationAttributesData?.teamAttributesNew?.defence?.avgScore || 0}
                    inPlayerIds={inPlayerIds}
                    outPlayerIds={outPlayerIds}
                    color={getBackgroundColor(teamAttributesData?.defence?.avgScore || 0)}
                    positionResults={positionResults}
                    teamId={teamId}
                  />
                </div>
              </div>
            </div>
          </div>
          {/* Content Section 2 - Attributes */}
          <div style={{ width: '100%'}}>
            <SimulationAttributes
              initialAttributesData={teamAttributesData}
              simulationAttributesData={simulationAttributesData}
              inPlayerIds={inPlayerIds}
              outPlayerIds={outPlayerIds}
              positionResults={positionResults}
              teamId={teamId}
            />
          </div>
        </div> 
      </div>


      <p style={{marginTop: "30px", width: '1065px', fontFamily: 'Aeonik, sans-serif', fontSize: '20px', fontStyle: 'normal', fontWeight: 300, color:'#7C7D79' }} className="valuegraph-toggle-text">
        Playing Style: A team’s playing style is calculated using 22 statistical measures that capture how frequently they perform certain actions on the pitch and the types of actions they take. Stylistic Fit measures how well the players in the team are suited to playing the target team’s style
      </p>

      <div style={{width: '1065px', display: 'flex', flexDirection: "column", gap: "10px", backgroundColor: "#F2F5EE", padding: "8px", borderRadius: "8px", border: "1px solid #DADADA" }}>
        <div className='values-container'>
          <div className='values-box' style={{ backgroundColor: "white", width: '100%', height: "auto" }}>
            <div className='values-box-content'>
              <div className='content-value'>
                <LabelText className="secondary-cta-text">Stylistic fit</LabelText>
                <div className='pitch-selection-container' style={{ padding: '0px' }}>
                  {inPlayerIds.length > 0 && outPlayerIds.length > 0 && hasPlayersFromDifferentClubs({positionResults, teamId}) && (
                    <LabelNumber className='event-player-card-details' style={{ color: getImprovement() > 0 ? '#00D1A8' : '#FF3864' }}>
                      {Math.abs(getImprovement()) !== 0 && (<img height={16} width={16} src={getImprovement() > 0 ? PositiveArrow : NegativeArrow} alt="negative" />)}
                      {`${Math.abs(getImprovement()) === 0 ? "" : Math.abs(getImprovement())}`}
                    </LabelNumber>
                  )}
                  <div
                    className="values-content"
                    style={{
                      backgroundColor: getBackgroundColor(
                        inPlayerIds.length === 0 && outPlayerIds.length === 0
                          ? archeTypeBy === "coach"
                            ? getStylisticFitForCoach() ?? 0
                            : archeTypeBy === "archetype"
                            ? getStylisticFit() ?? 0
                            : archeTypeBy === "team"
                            ? getCompareStylisticFit() ?? 0
                            : getAfterScore() ?? 0
                          : getAfterScore() ?? 0
                      ),
                      border: `1px solid ${getBorderColor(
                        inPlayerIds.length === 0 && outPlayerIds.length === 0
                          ? archeTypeBy === "coach"
                            ? getStylisticFitForCoach() ?? 0
                            : archeTypeBy === "archetype"
                            ? getStylisticFit() ?? 0
                            : archeTypeBy === "team"
                            ? getCompareStylisticFit() ?? 0
                            : getAfterScore() ?? 0
                          : getAfterScore() ?? 0
                      )}`,
                    }}
                  >
                    <LabelNumber className='event-player-card-details'>{`${
                      inPlayerIds.length === 0 && outPlayerIds.length === 0
                        ? (archeTypeBy === "coach"
                            ? getStylisticFitForCoach() ?? 0
                            : archeTypeBy === "archetype"
                            ? getStylisticFit() ?? 0
                            : archeTypeBy === "team"
                            ? getCompareStylisticFit() ?? 0
                            : getAfterScore())
                        : getAfterScore()
                    }`}</LabelNumber>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Content Section 1 - Stylistic Fit */}
        <div className='team-playing-style spider-graph-for-pdf' style={{ width:'calc(100% - 40px)',}}>
          <div className='style-header-container'>
            <div className='form-buttons-container'>
              <LabelText className="player-detail-given-name">{activeArcheTypeName}</LabelText>
            </div>
            <div className='pitch-selection-container'>
              <div className="archtype-info">
                <div className="archtype-tag" style={{ background: inPlayerIds.length > 0 && outPlayerIds.length > 0 && hasPlayersFromDifferentClubs({positionResults, teamId}) ? "#CFE6F4" : '#64ADDB' }}></div>
                <LabelText className="archtype-tag-text">Defensive</LabelText>
              </div>
              <div className="archtype-info">
                <div className="archtype-tag" style={{ background: inPlayerIds.length > 0 && outPlayerIds.length > 0 && hasPlayersFromDifferentClubs({positionResults, teamId}) ? "#CFE6F4" : '#C9F0B5' }}></div>
                <LabelText className="archtype-tag-text">Build up play</LabelText>
              </div>
              <div className="archtype-info">
                <div className="archtype-tag" style={{ background: inPlayerIds.length > 0 && outPlayerIds.length > 0 && hasPlayersFromDifferentClubs({positionResults, teamId}) ? "#CFE6F4" : '#FFC2C2' }}></div>
                <LabelText className="archtype-tag-text">Final third</LabelText>
              </div>
            </div>
          </div>
          <div style={{ display: 'flex', gap: '20px', paddingTop: '20px' }}>
            <div className="style-compariosn-containr">
              {archeTypeBy === 'archetype' && (
              <div className="comparison-content">
                <input type="radio" id="archetype" className="custom-radio" name="archetype"
                  checked={archeTypeBy === 'archetype'}
                />
                <div className='values-box-content'>
                  <LabelText className="secondary-cta-text">Playing style's top performers </LabelText>
                  <LabelNumber className='valuegraph-toggle-text'>{(getClubName() !== "" && getSeasonName() !== "" ? `${getClubName()} - ${getSeasonName()}` : '')}</LabelNumber>
                  <LabelNumber className='valuegraph-toggle-text'>{targetedArcheTypeFormation}</LabelNumber>
                  <LabelNumber className='valuegraph-toggle-text'>{getStylisticFit() !== "" ? `stylistic fit = ${getStylisticFit()}` : ""}</LabelNumber>
                </div>
              </div>
            )}
            {archeTypeBy === 'coach' && (
              <div className="comparison-content">
                <input type="radio" id="coach" className="custom-radio" name="archetype"
                  checked={archeTypeBy === 'coach'}
                />
                <div className='values-box-content'>
                  <LabelText className="secondary-cta-text">Manager's best season </LabelText>
                  <LabelNumber className='valuegraph-toggle-text'>{(getClubNameForCoach() !== "" && getSeasonNameForCoach() !== "" ? `${getClubNameForCoach()} - ${getSeasonNameForCoach()}` : '')}</LabelNumber>
                  <LabelNumber className='valuegraph-toggle-text'>{`${targetedFormation}: ${getPlayingStyleForCoach()}`}</LabelNumber>
                  <LabelNumber className='valuegraph-toggle-text'>{getStylisticFitForCoach() !== "" ? `stylistic fit = ${getStylisticFitForCoach()}` : ""}</LabelNumber>
                </div>
              </div>
            )}
              <div className="archtype-info">
                {compareClubLogoUrl && compareClubName && (
                  <>
                    <input type="radio" id="team" className="custom-radio" name="archetype"
                      checked={archeTypeBy === 'team'}
                    />
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                        <img src={compareClubLogoUrl} width={18} height={18} alt="club-logo" className="club-logo" />
                        <LabelText className="archtype-tag-text">{compareClubName}</LabelText>
                      </div>
                      <LabelNumber className='valuegraph-toggle-text'>{compareClubseasonLabel !== '' && `${compareClubseasonLabel} SEASON`}</LabelNumber>
                      <LabelNumber className="valuegraph-toggle-text">{`Stylistic Fit = ${Number(((simulationData?.similarity?.before ?? 0) * 100).toFixed(2))}`}</LabelNumber>
                    </div>
                  </>
                )}
              </div>
            </div>
            <div>
              {simulationData && (
                <>
                  <SpiderSwapGraph
                    data={processTeamSwapArchetypeData(simulationData!)}
                    comparisonData={comparisonTeamData?.[0] ? processTeamArchetypeData(comparisonTeamData[0]!) : undefined}
                    isForComparison={clubCompareId > 0}
                    height={600}
                    width={682}
                    inPlayerIds={inPlayerIds}
                    outPlayerIds={outPlayerIds}
                    isComparisonBlackLine={isCompareBalckLine}
                    positionResults={positionResults}
                    teamId={teamId}
                  />
                  <div style={{ position: 'relative', bottom: '50%' }}>{swapDataLoading && <LoadingSpinner />}</div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SystemFitValuesAndContent;